import { StorageWrapper } from './storage'

export interface UTMData {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
  from_url?: boolean
}

const LS_LAST = '__et_utm_last'
const LS_FIRST = '__et_utm_first'
const SS_SESSION_FLAG = '__et_utm_from_url'

const localStore = new StorageWrapper('local')
const sessionStore = new StorageWrapper('session')

/**
 * 解析 URL + hash 中的 utm 参数
 */
export function parseUTMFromURL(): UTMData | null {
  if (typeof window === 'undefined') return null

  const search = window.location.search || ''
  const hash = window.location.hash || ''

  const query = new URLSearchParams(
    search + (hash.includes('?') ? hash.slice(hash.indexOf('?')) : ''),
  )

  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']

  let found = false
  const utm: UTMData = {}

  keys.forEach((key) => {
    const val = query.get(key)
    if (val) {
      found = true
      ;(utm as Record<string, string>)[key] = val
    }
  })

  return found ? utm : null
}

/**
 * 初始化 UTM
 * - 若 URL 有 UTM → 解析 + 保存 + 标记 session
 * - 否则 → 读取缓存（last-touch）
 */
export function initUTM(): UTMData | null {
  const utmFromUrl = parseUTMFromURL()

  if (utmFromUrl) {
    // 当前 session 有 URL UTM
    sessionStore.setItem(SS_SESSION_FLAG, true)

    // 写入 last-touch
    localStore.setItem(LS_LAST, utmFromUrl)

    // 写入 first-touch（仅第一次）
    if (!localStore.getItem(LS_FIRST)) {
      localStore.setItem(LS_FIRST, utmFromUrl)
    }

    return { ...utmFromUrl, from_url: true }
  }

  // 没有 URL → 从缓存拿 last-touch
  const last = localStore.getItem<UTMData>(LS_LAST)
  if (last) {
    const fromUrl = sessionStore.getItem<boolean>(SS_SESSION_FLAG) === true
    return { ...last, from_url: fromUrl }
  }

  return null
}

/**
 * 获取当前事件应携带的 UTM（last-touch）
 */
export function getCurrentUTM(): UTMData | null {
  const last = localStore.getItem<UTMData>(LS_LAST)
  if (!last) return null

  const fromUrl = sessionStore.getItem<boolean>(SS_SESSION_FLAG) === true
  return { ...last, from_url: fromUrl }
}

/**
 * 注册/激活事件使用 first-touch
 */
export function getFirstUTM(): UTMData | null {
  return localStore.getItem<UTMData>(LS_FIRST)
}

/**
 * 默认导出 - 用于 Client 初始化
 * 兼容旧的 UTM(appid, urlQueryObj, domain, cookie_expire) 调用方式
 * 注：参数暂时保留以兼容旧代码，实际使用 initUTM() 实现
 */
export default function UTM(): UTMData | null {
  return initUTM()
}
